import { jsxs as n, jsx as s } from "react/jsx-runtime";
import { c as t, e as p } from "../../vendor-DgBgaXRO.js";
import '../../assets/index10.css';const m = "_i9spq_md", i = "_i9spq_progress", d = "_i9spq_sm", r = {
  "bounce-center": "_i9spq_bounce-center",
  md: m,
  progress: i,
  sm: d
};
function b({ size: e = "md", className: o, ...a }) {
  const c = t(r.progress, r[e], o);
  return /* @__PURE__ */ n(p, { isIndeterminate: !0, className: c, "aria-label": a["aria-label"], children: [
    /* @__PURE__ */ s("span", {}),
    /* @__PURE__ */ s("span", {}),
    /* @__PURE__ */ s("span", {})
  ] });
}
export {
  b as DotProgress
};
//# sourceMappingURL=index.js.map
